import { defineStore } from "pinia";

export const useDataFiltersStore = defineStore("useFiltersStore", {
  state: () => ({
    fromDate: null,
    toDate: null
  })
});
